import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  clearUploadedVideo,
  getCampaignElementById,
  getIpAddress,
  selectVideo,
  getCampaignId,
  getCampaignBanner,
  getUseCampaignBanner,
  getCampaignLanguage,
  getMediaSubmissionIdForElement,
  setQuestionVideoUploadSuccess,
  setQuestionVideoUploadError,
  setSelectedVideoFile,
  getIsUploadingVideo,
} from '../../redux/modules/campaignLandingPage';
import styles from './VideoUploadButton.module.less';
import { ACCEPT_TYPES } from '../../constants';
import { StyledOutlineBrandingButton } from './styles';
import { getTranslation } from '../../translations/dictionary';
import { getFileSizeLabel } from '../../utils/getFileSize';

const VideoUploadButton = ({
  _clearUploadedVideo,
  _selectVideo,
  _setSelectedVideoFile,
  qid,
  userIpAddress,
  isDirectRecording = false,
  campaignId,
  backgroundColor,
  useBanner,
  language,
  isUploadingVideo,
  createMediaSubmissionFn,
  shouldHide
}) => {
  const recordLabel = getTranslation('record_video_label', language) || 'Record a Video';
  const uploadLabel = getTranslation('upload_video_label', language) || 'Upload a Video';

  const fileInput = useRef(null);
  const buttonLabel = isDirectRecording ? recordLabel : uploadLabel;

  const mediaSubmission = {
    isRecorded: isDirectRecording ? true : false,
    userAgent: navigator.userAgent,
    userIp: userIpAddress,
    screenResolution: `${window.outerWidth}x${window.outerHeight}`,
    campaignId
  };

  function handleFileSelect(files) {
    _clearUploadedVideo(qid);
    const [file] = files;
    _setSelectedVideoFile(qid, file);

    mediaSubmission.mimeType = file.type;
    mediaSubmission.fileSize = getFileSizeLabel(file.size);

    // Save file type so we can use it in the video preview
    // Create an object URL and persist it to store
    const objectUrl = window.URL.createObjectURL(file);
    _selectVideo(qid, objectUrl, file.type);

    // create media submission and get back mediaId and fileName
    createMediaSubmissionFn({ data: mediaSubmission });
  }

  const fileInputProps = {
    type: 'file',
    capture: isDirectRecording ? 'user' : null,
    disabled: isUploadingVideo,
    id: `vpUploadInput-${qid}-${isDirectRecording}`,
    accept: ACCEPT_TYPES.VIDEO,
    ref: fileInput,
    className: styles.vpVisuallyHidden,
    onChange: (e) => handleFileSelect(e.target.files),
  };

  const useCustomStyle = useBanner && backgroundColor;
  const sx = { gap: '5px' };
  if (shouldHide) {
    sx.display = 'none';
  }

  return (
    <>
      <StyledOutlineBrandingButton
        component="label"
        htmlFor={`vpUploadInput-${qid}-${isDirectRecording}`}
        variant="outlined"
        disabled={isUploadingVideo}
        backgroundColor={backgroundColor}
        custom={useCustomStyle}
        sx={sx}
      >
        <Icon icon={isDirectRecording ? 'circle' : 'upload'} />
        {buttonLabel}
      </StyledOutlineBrandingButton>
      <input {...fileInputProps} />
    </>
  );
};

VideoUploadButton.propTypes = {
  _clearUploadedVideo: PropTypes.func,
  _selectVideo: PropTypes.func,
  campaignElement: PropTypes.object,
  hasUploadedVideo: PropTypes.bool,
  hasUploadFailure: PropTypes.bool,
  qid: PropTypes.string,
  signedUrl: PropTypes.string,
  userIpAddress: PropTypes.string,
  isDirectRecording: PropTypes.bool,
  campaignId: PropTypes.number,
  backgroundColor: PropTypes.string,
  language: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  campaignElement: getCampaignElementById(state, ownProps.qid),
  userIpAddress: getIpAddress(state),
  campaignId: getCampaignId(state),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  language: getCampaignLanguage(state),
  mediaSubmissionId: getMediaSubmissionIdForElement(state, ownProps.qid),
  isUploadingVideo: getIsUploadingVideo(state, ownProps.qid),
});

const mapDispatchToProps = {
  _clearUploadedVideo: clearUploadedVideo,
  _selectVideo: selectVideo,
  _setQuestionVideoUploadSuccess: setQuestionVideoUploadSuccess,
  _setQuestionVideoUploadError: setQuestionVideoUploadError,
  _setSelectedVideoFile: setSelectedVideoFile
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoUploadButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoUploadButton.jsx